import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from '../../core/services/app-config.service';
import {
  EgridMeta,
  GbgrundstueckService,
  GrundstueckDetailEntryMeta,
  StandardrechtMasterDetailEntryMeta
} from 'app/core/gb-api';
import { TimepointCtx, TimepointService } from '../../core/services/timepoint.service';
import { EigentumanteilMasterDetailVM, EigentumViewmodelService } from '../../core/services/eigentum-viewmodel.service';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { catchError, map, tap } from 'rxjs/operators';
import { ListLoaderInfiniteBuilder } from '../../shared/components/list-loader/list-loader-infinite';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import {
  BodenbedeckungViewmodelService,
  ViewModelBodenbedeckungEntry
} from '../../core/services/bodenbedeckung-viewmodel.service';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { ComparatorService } from '../../shared/services/comparator-service';
import {
  AvadresseService,
  AvBemerkungMasterDetailEntry,
  AvbemerkungService,
  AvflaechenanteilService,
  AvflaecheService,
  AvgbplanService,
  GbplanMasterDetailEntry,
  GrundstueckadresseDetailEntry,
  GrundstueckFlaecheMasterDetailEntryMeta,
  GrundstueckFlaechenanteilMasterDetailEntry,
  GrundstueckId
} from '../../core/av-api';
import { NavTarget } from '../../shared/components/link/link.component';
import {
  LastRechtRootEntryVm,
  StandardrechtViewmodelService
} from '../../core/services/standardrecht-viewmodel.service';
import { throwError } from 'rxjs';
import { RechtArt } from '../../shared/widgets/standardrecht-table/standardrecht-table.component';
import { CapiLoginService } from 'app/core/extension/login/capi-login-service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { log } from '../../log/log';
import { FormatConfigService } from 'app/core/services/format-config.service';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import {
  GrundpfandrechtViewmodelService,
  RootBelastungVm
} from '../../core/services/grundpfandrecht-viewmodel.service';
import {
  AbstractRangregelungVm,
  RangregelungViewmodelService
} from '../../core/services/rangregelung-viewmodel.service';
import { PersonstammpersonService } from '../../core/personstamm-api';
import { CapSpinnerSmallComponent } from '../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { BeschreibungTableWrapperComponent } from '../../shared/components/table/beschreibung-table-wrapper.component';
import {
  GrundbuchplaeneTableComponent
} from '../../shared/widgets/grunbuchplaene-table/grundbuchplaene-table.component';
import { CapAlertComponent } from '../../core/extension/exceptions/cap-alert.component';
import {
  LagebezeichnungTableComponent
} from '../../shared/widgets/lagebezeichnung-table/lagebezeichnung-table.component';
import { BodenbedeckungTableComponent } from '../../shared/widgets/bodenbedeckung-table/bodenbedeckung-table.component';
import { FlaechenanteilTableComponent } from '../../shared/widgets/flaechenanteil-table/flaechenanteil-table.component';
import { KuhrechtComponent } from '../../shared/widgets/grundstueck/table-kuhrecht/kuhrecht.component';
import {
  AlpgrundstueckeComponent
} from '../../shared/widgets/grundstueck/table-alpgrundstuecke/alpgrundstuecke.component';
import {
  GrundstueckBemerkungComponent
} from '../../shared/widgets/grundstueck/grundstueck-bemerkung/grundstueck-bemerkung.component';
import { RubrikComponent } from '../../shared/components/rubrik/rubrik.component';
import { SonderrechtIcpComponent } from '../table-sonderrecht-icp/sonderrecht-icp.component';
import { GrundstueckKopfIcpComponent } from '../grundstueck-kopf-icp/grundstueck-kopf-icp.component';
import { GebaeudeIcpComponent } from '../gebaude-icp/gebaeude-icp.component';
import { EigentumTableIcpComponent } from '../eigentum-table-icp/eigentum-table-icp.component';
import { AvbemerkungTableIcpComponent } from '../avbemerkung-table-icp/avbemerkung-table-icp.component';
import {
  DominierteGrundstueckeIcpComponent
} from '../dominierte-grundstuecke-icp/dominierte-grundstuecke-icp.component';
import { RangregelungTableIcpComponent } from '../rangregelung-table-icp/rangregelung-table-icp.component';
import { StammgrundstueckIcpComponent } from '../stammgrundstueck-icp/stammgrundstueck-icp.component';
import {
  GrundstueckHaengigeIcpComponent
} from '../haengige-icp/grundstueck-haengige-icp/grundstueck-haengige-icp.component';
import { GrundpfandrechtTableIcpComponent } from '../grundpfandrecht-table-icp/grundpfandrecht-table-icp.component';
import { TranslatePipe } from '@ngx-translate/core';
import { StandardrechtTableIcpComponent } from '../standardrecht-table-icp/standardrecht-table-icp.component';
import { GrundstueckflaecheIcpComponent } from '../table-grundstueckflaeche-icp/grundstueckflaeche-icp.component';
import RechtArtEnum = StandardrechtMasterDetailEntryMeta.RechtArtEnum;

@Component({
  selector: 'cap-grundstueck-icp-detail',
  templateUrl: './grundstueck-icp-detail.component.html',
  imports: [
    CapSpinnerSmallComponent,
    BeschreibungTableWrapperComponent,
    GrundbuchplaeneTableComponent,
    CapAlertComponent,
    LagebezeichnungTableComponent,
    BodenbedeckungTableComponent,
    FlaechenanteilTableComponent,
    KuhrechtComponent,
    AlpgrundstueckeComponent,
    DominierteGrundstueckeIcpComponent,
    GrundstueckBemerkungComponent,
    AvbemerkungTableIcpComponent,
    RubrikComponent,
    EigentumTableIcpComponent,
    SonderrechtIcpComponent,
    GebaeudeIcpComponent,
    GrundstueckKopfIcpComponent,
    RangregelungTableIcpComponent,
    StammgrundstueckIcpComponent,
    GrundstueckHaengigeIcpComponent,
    GrundpfandrechtTableIcpComponent,
    TranslatePipe,
    StandardrechtTableIcpComponent,
    GrundstueckflaecheIcpComponent
  ]
})
export class GrundstueckIcpDetailComponent extends AbstractComponent implements OnInit {
  rubrik = Rubrik;
  grundstueckEntry: GrundstueckDetailEntryMeta;
  gsId: GrundstueckId;
  egrid: EgridMeta;

  bodenbedeckungListLoader: ListLoader<ViewModelBodenbedeckungEntry>;
  lagebezeichnungListLoader: ListLoader<GrundstueckadresseDetailEntry>;
  plaeneListLoader: ListLoader<GbplanMasterDetailEntry>;
  flaechenListLoader: ListLoader<GrundstueckFlaecheMasterDetailEntryMeta>;
  flaechenanteileListLoader: ListLoader<GrundstueckFlaechenanteilMasterDetailEntry>;
  eigentumListLoader: ListLoader<EigentumanteilMasterDetailVM>;
  bemerkungListLoader: ListLoader<AvBemerkungMasterDetailEntry>;
  dienstbarkeitenListLoader: ListLoader<LastRechtRootEntryVm>;
  grundlastenListLoader: ListLoader<LastRechtRootEntryVm>;
  anmerkungenListLoader: ListLoader<LastRechtRootEntryVm>;
  sdrDienstbarkeitLoader: ListLoader<LastRechtRootEntryVm>;
  vormerkungenListLoader: ListLoader<LastRechtRootEntryVm>;
  pfandrechteListLoader: ListLoader<RootBelastungVm>;
  rangregelungenListLoader: ListLoader<AbstractRangregelungVm>;

  eigentumErrored = false;
  dienstbarkeitenErrored = false;
  anmerkungenErrored = false;
  grundlastenErrored = false;
  flaechenAnteileErrored = false;
  bodenbedeckungErrored = false;
  lagebezeichnungErrored = false;
  plaeneErrored = false;
  flaechenErrored = false;
  bemerkungenErrored = false;
  sdrErrored = false;
  vormerkungenErrored = false;
  pfandrechteErrored = false;
  rangregelungenErrored = false;

  mitAdressen = true;
  parameterAnzeigeStandardrecht = false;
  parameterZugriffEigentuemer = false;
  parameterBelegeAnzeigen = false;
  showRechtsgrund = false;
  hasLoggedInUser = false;
  isEigentuemer = false;
  verknuepfteEigentuemerIds: string[] = [];

  navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK_ES;

  private timepointCtx: TimepointCtx;
  protected ersterfassungUebergeben: boolean;
  private readonly PAGE_SIZE = 5;
  private readonly CHUNK_SIZE = 100;
  rechtArt = RechtArt;

  setDienstbarkeitenErrored(value: boolean): void {
    this.dienstbarkeitenErrored = value;
  }

  setGrundlastenErrored(value: boolean): void {
    this.grundlastenErrored = value;
  }

  setAnmerkungErrored(value: boolean): void {
    this.anmerkungenErrored = value;
  }

  setSdrErrored(value: boolean): void {
    this.sdrErrored = value;
  }

  setVormerkungenErrored(value: boolean): void {
    this.vormerkungenErrored = value;
  }

  setPfandrechteErrored(value: boolean): void {
    this.pfandrechteErrored = value;
  }

  setRangregelungenErrored(value: boolean): void {
    this.rangregelungenErrored = value;
  }

  constructor(
    private appConfigService: AppConfigService,
    private flaechenanteilServce: AvflaechenanteilService,
    private adresseService: AvadresseService,
    private planService: AvgbplanService,
    private eingtumViewModelService: EigentumViewmodelService,
    private bodenbedeckungViewmodelService: BodenbedeckungViewmodelService,
    private flaecheService: AvflaecheService,
    private grundstueckService: GbgrundstueckService,
    private personStammService: PersonstammpersonService,
    private bemerkungService: AvbemerkungService,
    private comparatorService: ComparatorService,
    private timepointService: TimepointService,
    private route: ActivatedRoute,
    private router: Router,
    private standardrechtViewmodelService: StandardrechtViewmodelService,
    private grundpfandrechtViewmodelService: GrundpfandrechtViewmodelService,
    private rangregelungViewmodelService: RangregelungViewmodelService,
    private appformatConfigService: FormatConfigService,
    private permissionService: AppPermissionService,
    public loginService: CapiLoginService
  ) {
    super();
    keysToTranslate<string>(['grundstueck.rubrik.OeffentlicheAnmerkungen']);
    this.addSub(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.parameterAnzeigeStandardrecht = <any>config?.parameters.STANDARDRECHTE_ANZEIGEN;
        this.parameterZugriffEigentuemer = <any>config?.parameters.ZUGRIFF_EIGENTUEMER;
        this.parameterBelegeAnzeigen = <any>config?.parameters.BELEGEANZEIGEN;
      })
    );
  }

  ngOnInit(): void {
    this.hasLoggedInUser = this.loginService.userLoggedIn;
    this.mitAdressen = this.permissionService.hasPermission('ICP_AUTHORIZED');
    this.grundstueckEntry = undefined;
    this.timepointCtx = this.timepointService.timepointCtx;
    this.route.queryParamMap.subscribe((q) => {
      this.grundstueckEntry = undefined;
      this.gsId = undefined;
      this.egrid = undefined;
      if (q.get('id')) {
        this.gsId = { id: q.get('id') };
      }
      if (q.get('egrid')) {
        this.egrid = { value: q.get('egrid') };
      }
      if (this.parameterZugriffEigentuemer) {
        this.checkIfEigentuemerAndLoadGrundstueck();
      } else {
        this.isEigentuemer = false;
        this.showRechtsgrund = this.isEigentuemer || (this.parameterBelegeAnzeigen && this.hasLoggedInUser);
        this.loadGrundstueck();
      }
    });
  }

  showRubrik(rubrik: Rubrik): boolean {
    if (!this.grundstueckEntry) {
      return false;
    }
    switch (this.grundstueckEntry.grundstueckArt) {
      case 'STOCKWERK':
        return [Rubrik.STAMMGRUNDSTUECK, Rubrik.SONDERRECHT, Rubrik.DOMINIERTE_GRUNDSTUECKE].some((r) => r === rubrik);
      case 'SDR':
        return [
          Rubrik.FLAECHE,
          Rubrik.PLAENE,
          Rubrik.FLURNAME,
          Rubrik.GEBAEUDE,
          Rubrik.FLAECHENANTEIL,
          Rubrik.DOMINIERTE_GRUNDSTUECKE,
          Rubrik.AV_ANMERKUNGEN,
          Rubrik.SDR
        ].some((r) => r === rubrik);
      case 'LIEGENSCHAFT':
        return [
          Rubrik.FLAECHE,
          Rubrik.PLAENE,
          Rubrik.FLURNAME,
          Rubrik.BODENBEDECKUNG,
          Rubrik.GEBAEUDE,
          Rubrik.FLAECHENANTEIL,
          Rubrik.DOMINIERTE_GRUNDSTUECKE,
          Rubrik.AV_ANMERKUNGEN
        ].some((r) => r === rubrik);
      case 'MITEIGENTUM':
        return [Rubrik.STAMMGRUNDSTUECK, Rubrik.DOMINIERTE_GRUNDSTUECKE].some((r) => r === rubrik);
      case 'UNBEKANNT':
        return false;
      case 'FOLIO':
        return [Rubrik.KUHRECHTE, Rubrik.DOMINIERTE_GRUNDSTUECKE].some((r) => r === rubrik);
      case 'BERGWERK':
        return false;
    }
  }

  private checkIfEigentuemerAndLoadGrundstueck() {
    if (this.gsId) {
      this.addSub(
        this.grundstueckService.isEigentuemerOfGrundstueck(this.gsId?.id).subscribe({
          next: (isEigentuemer) => this.setEigentuemerAndLoadGrundstueck(isEigentuemer)
        })
      );
    } else if (this.egrid) {
      this.addSub(
        this.grundstueckService.isEigentuemerOfGrundstueckByEgrid(this.egrid.value).subscribe({
          next: (isEigentuemer) => this.setEigentuemerAndLoadGrundstueck(isEigentuemer)
        })
      );
    }
  }

  private setEigentuemerAndLoadGrundstueck(isEigentuemer: boolean) {
    this.isEigentuemer = isEigentuemer;
    this.showRechtsgrund = this.isEigentuemer || (this.parameterBelegeAnzeigen && this.hasLoggedInUser);
    if (isEigentuemer) {
      this.loadVerknuepfteEigentuemerIds();
    }
    this.loadGrundstueck();
  }

  private loadGrundstueck() {
    this.resetOccurredErrors();
    this.addSub(
      this.lookupGrundstueckObservable().subscribe({
        next: (gsDetail) => {
          this.grundstueckEntry = gsDetail;
          this.gsId = gsDetail.id;
          this.flaechenanteileListLoader = this.createFlaechenanteileLoader(gsDetail.egrid);
          this.bodenbedeckungListLoader = this.createBodenbedeckungListLoader(gsDetail.id);
          this.flaechenListLoader = this.createFlaecheListLoader(gsDetail.id);
          this.lagebezeichnungListLoader = this.createFlurnamenListLoader(gsDetail.id);
          this.plaeneListLoader = this.createGbPlanListLoader(gsDetail.id);
          this.bemerkungListLoader = this.createBemerkungLoader(gsDetail.id);
          this.eigentumListLoader = this.createEigentumLoader(gsDetail.id);
          if (this.parameterAnzeigeStandardrecht) {
            if (this.hasLoggedInUser) {
              this.dienstbarkeitenListLoader = this.createStandardrechtListLoader(
                gsDetail.id,
                'DIENSTBARKEIT',
                this.setDienstbarkeitenErrored
              );
              this.grundlastenListLoader = this.createStandardrechtListLoader(gsDetail.id, 'GRUNDLAST', this.setGrundlastenErrored);
              this.anmerkungenListLoader = this.createStandardrechtListLoader(gsDetail.id, 'ANMERKUNG', this.setAnmerkungErrored);
              this.sdrDienstbarkeitLoader = this.createStandardrechtListLoader(gsDetail.id, 'SDR_DIENSTBARKEIT', this.setSdrErrored);
              if (this.isEigentuemer) {
                this.vormerkungenListLoader = this.createStandardrechtListLoader(gsDetail.id, 'VORMERKUNG', this.setVormerkungenErrored);
                this.pfandrechteListLoader = this.createPfandrechtListLoader(gsDetail.id, this.setPfandrechteErrored);
                this.rangregelungenListLoader = this.createRangregelungListLoader(gsDetail.id, this.setRangregelungenErrored);
              }
            }
          }
        },
        error: (err) => {
          if (err.status === 404) {
            this.router.navigate(['/home/notfound']);
          } else if (err.status === 400) {
            this.router.navigate(['/home/invalidrequest']);
          } else {
            throw err;
          }
        }
      })
    );
  }

  private resetOccurredErrors() {
    this.eigentumErrored = false;
    this.dienstbarkeitenErrored = false;
    this.anmerkungenErrored = false;
    this.grundlastenErrored = false;
    this.flaechenAnteileErrored = false;
    this.bodenbedeckungErrored = false;
    this.lagebezeichnungErrored = false;
    this.plaeneErrored = false;
    this.flaechenErrored = false;
    this.bemerkungenErrored = false;
    this.sdrErrored = false;
  }

  private lookupGrundstueckObservable() {
    if (this.gsId) {
      return this.grundstueckService.loadGrundstueckById(
        this.gsId.id,
        'OHNE_HIST',
        this.timepointCtx.timepointIso,
        this.timepointCtx.timepointId
      );
    } else if (this.egrid) {
      return this.grundstueckService.loadGrundstueckByEgrid(
        'OHNE_HIST',
        this.egrid.value,
        this.timepointCtx.timepointIso,
        this.timepointCtx.timepointId
      );
    } else {
      log.warn('Malformed URL! Request: ' + encodeURI(this.router.url));
      // forcing HTTP API to produce a valid Observable with proper error object
      return this.grundstueckService.loadGrundstueckById('', 'OHNE_HIST', null, null);
    }
  }

  private loadVerknuepfteEigentuemerIds() {
    this.addSub(
      this.personStammService.getCurrentPersonstammIdsForEigentuemer().subscribe((response) => {
        this.verknuepfteEigentuemerIds = response ? response : [];
      })
    );
  }

  private createFlaechenanteileLoader(egrid: EgridMeta) {
    const grundstuecknummer = this.grundstueckEntry.grundstueckNummern[0];
    const flaechenanteile = this.flaechenanteilServce
      .loadGrundstueckFlaechenanteilSichtGrundstueckByFachId(
        egrid ? egrid.value : undefined,
        grundstuecknummer.nummer,
        grundstuecknummer.nummerZusatz,
        grundstuecknummer.nummer3,
        grundstuecknummer.nummer4,
        grundstuecknummer.gbGemeinde.bfsNummer,
        grundstuecknummer.gbGemeinde.kreisNummer
      )
      .pipe(
        map((loadedFlaechenanteile) => {
          if (loadedFlaechenanteile) {
            return loadedFlaechenanteile.sort((a, b) => this.comparatorService.flaechenanteileComparator(a, b, this.gsId));
          }
          return null;
        }),
        catchError((err) => {
          this.flaechenAnteileErrored = true;
          return throwError(err);
        })
      );
    const loader = new ListLoaderObservable<GrundstueckFlaechenanteilMasterDetailEntry>(undefined, 1, flaechenanteile);
    this.addLoader(loader);
    return loader;
  }

  private createBemerkungLoader(gsId: GrundstueckId) {
    const observable = this.bemerkungService
      .loadAvBemerkungSichtGrundstueck(
        gsId.id,
        this.timepointCtx.timepointIso,
        this.timepointCtx.timepointId,
        this.appConfigService.einstellungHistorischeDaten
      )
      .pipe(
        catchError((err) => {
          this.bemerkungenErrored = true;
          return throwError(err);
        })
      );
    const loader = new ListLoaderObservable<AvBemerkungMasterDetailEntry>(undefined, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private createEigentumLoader(gsId: GrundstueckId): ListLoader<EigentumanteilMasterDetailVM> {
    const observable = (offset: number, limit: number) => {
      return this.eingtumViewModelService
        .loadSichtByGrundstueckId(gsId, false, this.mitAdressen, true, offset, limit, this.subscriptions, this.isEigentuemer)
        .pipe(
          tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
          map((res) => res.entries),
          catchError((err) => {
            this.eigentumErrored = true;
            return throwError(err);
          })
        );
    };
    const loader = ListLoaderInfiniteBuilder.builder<EigentumanteilMasterDetailVM>()
      .setLookupItemFunc(observable)
      .setCurrentPage(1)
      .setPageSize(this.PAGE_SIZE)
      .setChunkSize(this.CHUNK_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }

  private createBodenbedeckungListLoader(gsId: GrundstueckId): ListLoader<ViewModelBodenbedeckungEntry> {
    const observable = this.bodenbedeckungViewmodelService.loadBodenbedeckungSichtGrundstueck(gsId).pipe(
      catchError((err) => {
        this.bodenbedeckungErrored = true;
        return throwError(err);
      })
    );
    const loader = new ListLoaderObservable<ViewModelBodenbedeckungEntry>(undefined, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private createFlaecheListLoader(gsId: GrundstueckId): ListLoader<GrundstueckFlaecheMasterDetailEntryMeta> {
    const observable = this.flaecheService
      .loadGrundstueckFlaecheSichtGrundstueck(
        //
        gsId.id, //
        this.timepointService.timepointCtx.timepointIso, //
        this.timepointService.timepointCtx.timepointId, //
        this.appConfigService.einstellungHistorischeDaten //
      )
      .pipe(
        catchError((err) => {
          this.flaechenErrored = true;
          return throwError(err);
        })
      );
    const loader = new ListLoaderObservable<GrundstueckFlaecheMasterDetailEntryMeta>(undefined, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private createGbPlanListLoader(gsId: GrundstueckId): ListLoader<GbplanMasterDetailEntry> {
    const obs = this.planService
      .loadGbPlanSichtGrundstueck(
        //
        gsId.id, //
        this.timepointService.timepointCtx.timepointIso, //
        this.timepointService.timepointCtx.timepointId, //
        this.appConfigService.einstellungHistorischeDaten //
      )
      .pipe(
        catchError((err) => {
          this.plaeneErrored = true;
          return throwError(err);
        })
      );
    const loader = new ListLoaderObservable(undefined, 1, obs);
    this.addLoader(loader);
    return loader;
  }

  private createFlurnamenListLoader(gsId: GrundstueckId): ListLoader<GrundstueckadresseDetailEntry> {
    const obs = this.adresseService
      .loadSichGrundstueck(
        //
        gsId.id, //
        this.timepointService.timepointCtx.timepointIso, //
        this.timepointService.timepointCtx.timepointId, //
        this.appConfigService.einstellungHistorischeDaten //
      )
      .pipe(
        catchError((err) => {
          this.lagebezeichnungErrored = true;
          return throwError(err);
        })
      );
    const loader = new ListLoaderObservable(undefined, 1, obs);
    this.addLoader(loader);
    return loader;
  }

  private createStandardrechtListLoader(
    gsId: GrundstueckId,
    rechtart: RechtArtEnum,
    boolSetter: Function
  ): ListLoader<LastRechtRootEntryVm> {
    const observable = (offset: number, limit: number) => {
      return this.standardrechtViewmodelService.loadSichtByGrundstueckId(gsId, rechtart, offset, limit, this.subscriptions, true).pipe(
        map((res) => res.entries),
        catchError((err) => {
          if (err.status !== 403) {
            boolSetter.bind(this)(true);
            return throwError(err);
          }
          throw err;
        })
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<LastRechtRootEntryVm>()
      .setLookupItemFunc(observable)
      .setCurrentPage(1)
      .setPageSize(this.PAGE_SIZE)
      .setChunkSize(this.CHUNK_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }

  private createPfandrechtListLoader(gsId: GrundstueckId, boolSetter: (value: boolean) => void) {
    const observable = this.grundpfandrechtViewmodelService.loadSichtByGbGrundstueckId(gsId).pipe(
      tap((resp) => (this.ersterfassungUebergeben = resp.ersterfassungUebergeben)),
      map((res) => res.entries),
      catchError((err) => {
        if (err.status !== 403) {
          boolSetter.bind(this)(true);
          return throwError(err);
        }
        throw err;
      })
    );

    const loader = new ListLoaderObservable<RootBelastungVm>(this.PAGE_SIZE, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private createRangregelungListLoader(gsId: GrundstueckId, boolSetter: Function): ListLoader<AbstractRangregelungVm> {
    const observable = (offset: number, limit: number) => {
      return this.rangregelungViewmodelService.loadSichtByGrundstueckId(gsId, offset, limit, this.subscriptions).pipe(
        tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries),
        catchError((err) => {
          if (err.status !== 403) {
            boolSetter.bind(this)(true);
            return throwError(err);
          }
          throw err;
        })
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<AbstractRangregelungVm>()
      .setLookupItemFunc(observable)
      .setChunkSize(this.CHUNK_SIZE)
      .setPageSize(this.PAGE_SIZE)
      .setCurrentPage(1)
      .setPublishItemsWhenAllLoaded(true)
      .build();
    this.addLoader(loader);
    return loader;
  }
}

export enum Rubrik {
  FLAECHE,
  PLAENE,
  FLURNAME,
  BODENBEDECKUNG,
  GEBAEUDE,
  FLAECHENANTEIL,
  DOMINIERTE_GRUNDSTUECKE,
  AV_ANMERKUNGEN,
  STAMMGRUNDSTUECK,
  SONDERRECHT,
  KUHRECHTE,
  SDR
}
